/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import RequirePerm from '../../../auth/components/RequirePerm'
import { ManagementReportGeneratorPageLink } from './ManagementReportGeneratorPage'
import { Button } from '@mantine/core'

export type GenerateReportsButtonProps = {
  showLabel: boolean
}

function GenerateReportsButton (props: GenerateReportsButtonProps) {
  const intl = useIntl()
  const { showLabel, ...others } = props

  const label = intl.formatMessage({
    id: 'generate_reports',
    defaultMessage: 'Générer les rapports'
  })

  return (
    <RequirePerm
      permissions={['write:management-report']}
      render={() => (
        <Button
          component={ManagementReportGeneratorPageLink}
          {...others}
        >
          {showLabel
            ? label
            : null}
        </Button>
      )}
    />
  )
}

export default GenerateReportsButton
